import { FeatureConfigFacade } from './+state/feature-config.facade';

export const featureConfigInitializer = (
  featureConfigFacade: FeatureConfigFacade
) => {
  return () => featureConfigFacade.load();
};
